import styled from '@emotion/styled';

export const PageContainer = styled.div`
  width: 100%;
  padding: 0 !important;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  margin-bottom: ${(props: {
    hasDynamicFilters: boolean;
    hasQuickFilters: boolean;
  }) => (props.hasDynamicFilters ? '0.125rem' : '0')};
  padding: ${(props: { hasDynamicFilters: boolean }) =>
    props.hasDynamicFilters ? '1.875rem 1.5rem' : '0.9375rem 1.5rem'};
  padding-bottom: ${(props: { hasDynamicFilters: boolean }) =>
    props.hasDynamicFilters ? '18px' : '0'};
  left: 0;
  right: 0;
  box-shadow: ${(props: {
    hasDynamicFilters: boolean;
    hasQuickFilters: boolean;
  }) =>
    props.hasDynamicFilters && !props.hasQuickFilters
      ? `0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 0px rgb(0 0 0 / 12%)`
      : ``};
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  h1 {
    margin-right: 1.1875rem;
    font-size: 20px;
  }
`;

export const MetaContainer = styled.div`
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 14px;
`;

export const SavedFiltersContainer = styled.li`
  font-size: 16px;
  .saved-filter {
    p {
      margin: 5px 0;
    }

    button {
      font-size: 13px;
    }
  }
`;

export const SavedFilters = styled.div`
  padding: 0 10px;
  p {
    margin: 5px 0;
  }

  button {
    font-size: 13px;
  }
`;

export const FavoritesToggle = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
`;
